export const LANDING = '/';

export const HOME = '/home';

export const LOBBY = '/lobby';

export const IMPRINT = '/imprint';
export const PRIVACY = '/privacy';
